import { GetConnectionsReportResponse } from "api/portal";
import { useMemo } from "react";

export default function getTotalConnections(
  connectionsReport?: GetConnectionsReportResponse
): number {
  return Object.entries(connectionsReport || {}).reduce(
    (prev, curr) => prev + curr[1],
    0
  );
}

export const useCompanyLimitReached = (
  companyLimit: number | undefined,
  totalCompanies: number
): boolean => {
  return useMemo(
    () =>
      companyLimit !== undefined &&
      totalCompanies !== undefined &&
      companyLimit <= totalCompanies,
    [companyLimit, totalCompanies]
  );
};
